export default __webpack_public_path__ + "static/media/bars-solid.4db37cad.svg";